import type { InputFrame } from '../types';
import { getPlayer, clampToWalkable, type World } from '../world';

/** Durée (s) pendant laquelle l'animation d'attaque verrouille la direction du joueur. */
const ATTACK_FACING_LOCK = 0.3;

export function movementSystem(world: World, input: InputFrame, dt: number): void {
  const p = getPlayer(world);
  if (!p || !p.alive) return;
  const len = Math.hypot(input.move.x, input.move.y);
  if (len > 0) {
    const nx = input.move.x / len, ny = input.move.y / len;
    const speed = (world.content.classes[p.defId]?.speed ?? 200) * (1 + p.speedPct / 100);
    p.vel = { x: nx * speed, y: ny * speed };
    // pendant l'animation de tir, le sprite garde la direction du tir (pas de clignotement)
    if (!(p.anim === 'attack' && p.animTime < ATTACK_FACING_LOCK)) p.facing = { x: nx, y: ny };
    if (p.anim === 'idle' || p.anim === 'run') p.anim = 'run';
  } else {
    p.vel = { x: 0, y: 0 };
    if (p.anim === 'run') p.anim = 'idle';
  }
  p.pos = clampToWalkable({ x: p.pos.x + p.vel.x * dt, y: p.pos.y + p.vel.y * dt }, p.radius, world.room, p.pos);
}
